import React from "react";

import { landingSource } from "../../landing-build/landing-source";

class Home extends React.Component {
  componentDidMount() {
    // setTimeout(() => {
    //   window.stop();
    // });

    setTimeout(() => {
      document.open();
      document.write(landingSource);
      document.close();
    });
  }

  render() {
    return <div></div>;
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js